import IndustryPageTemplate from "./IndustryPageTemplate";
import { realEstateAgentsData } from "@/data/realEstateAgents";

export default function RealEstateAgentsPage() {
  return <IndustryPageTemplate data={realEstateAgentsData} />;
}
